import { indexTracks, snapToGrid } from './tracksModel';

/**
 * live_tracks.json (backend: video_tracks.LiveTracks), uploaded every ~20 s while the frames are processed: the
 * animals found so far in tracks.json's format, with positions only every `step` frames of the analysed clip.
 * The page plays the uploaded source video then, so frames are moved to the source's numbering (the clip starts
 * time_offset_sec in) and a frame between two samples shows the sample before it.
 */

/**
 * The overlay index for the source video, with `grid` telling frameAt to hold each sample for `step` frames. It spans
 * the whole source video (`sourceSeconds`): past the frames done so far there is then nothing to draw, where an index
 * ending at the last sample would hold that sample while the animals walk on.
 */
export const indexLive = (doc, sourceSeconds = 0) => {
	if (!doc?.tracks) return null;
	const fps = doc.fps || 30;
	const from = Math.round((doc.time_offset_sec || 0) * fps);
	const step = Math.max(1, doc.step | 0);
	const tracks = from
		? doc.tracks.map(tr => ({
				...tr,
				t: tr.t.map(t => t + from),
				t0: tr.t0 + from,
				confirmed_at: (tr.confirmed_at ?? tr.t0) + from,
			}))
		: doc.tracks;
	const nFrames = Math.max(from + (doc.n_frames | 0) + step, Math.ceil(sourceSeconds * fps) + 1);
	const index = indexTracks({ ...doc, tracks, n_frames: nFrames });
	return { ...index, grid: { from, step } };
};

/** The animals at the sample shown at video time `seconds`: [[x, y], ...] in source pixels. */
export const pointsAt = (index, seconds) => {
	if (!index) return [];
	const f = snapToGrid(index.grid, Math.round(seconds * index.fps));
	if (f < 0 || f >= index.nFrames) return [];
	const out = [];
	for (let i = index.perFrame[f]; i < index.perFrame[f + 1]; i += 1) {
		const tr = index.tracks[index.trackOf[i]];
		const j = index.pointOf[i];
		out.push([tr.x[j], tr.y[j]]);
	}
	return out;
};
